import convertLocaleStringToNumber from './convertLocaleStringToNumber';
export default function isValidNumber(value) {
  var n = convertLocaleStringToNumber(value);
  var valid = typeof n === 'number' && !Number.isNaN(n);
  return valid;
}